goog.provide('el8.uiwidget.ComponentDialog');

goog.require('el8.uiwidget.NewDialog');
goog.require('el8.model.base');
goog.require('el8.template.uiwidget.ComponentDialog');


/**
 * A dialog wrapper around the Component widget, used to
 * display the in-sync items from an EntitySet in a dialog.
 *
 * See, e.g., viewLabOrderSets.js
 */
el8.uiwidget.ComponentDialog = function(spec) {

    spec = spec || {};

    /**
     * @type {el8.uiwidget.Component}
     */
    this._component = spec.component || null;

    this._hasRefresh = (spec.hasRefresh === true); // defaults to false
    this._title = spec.title || '';

    /**
     * ComponentDialogs are not expected to hold fields for the
     * user to type in or to have buttons so it should be safe
     * to close on escape and to have an X button. Override these
     * if those assumptions are not true for your ComponentDialog */
    spec.showXButton = (spec.showXButton !== false); //defaults to true
    spec.closeOnEscape = (spec.closeOnEscape !== false); //defaults to true

    el8.uiwidget.NewDialog.apply(this, arguments);
};
el8.uiwidget.ComponentDialog.inheritsFrom(el8.uiwidget.NewDialog);


el8.uiwidget.ComponentDialog.prototype.setComponent = function(component) {
    this._component = component;
    return this;
};


el8.uiwidget.ComponentDialog.prototype._init = function() {
    el8.uiwidget.NewDialog.prototype._init.apply(this, arguments);
    if (this._hasRefresh) {
        this.getContentElt().prepend(
            el8.template.uiwidget.ComponentDialog.refreshTrigger());
        var that = this;
        this.getContainer().on('click', '.refresh-trigger',  function(e) {
            that.refresh(true);
        });
    }
};


el8.uiwidget.ComponentDialog.prototype.show = function(doLoad) {
    el8.uiwidget.NewDialog.prototype.show.apply(this, arguments);
    if (this._component) {
        this._component.show(doLoad);
    }
};


el8.uiwidget.ComponentDialog.prototype.refresh = function(doLoad) {
    if (this._component) { this._component.render(doLoad); }
};
